import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";
import { TESTIMONIALS } from "@/data/site";

const initials = (name) =>
  name.split(" ").map((n) => n[0]).slice(0, 2).join("").toUpperCase();

export const Testimonials = () => {
  return (
    <section id="testimonios" data-testid="testimonials-section" className="relative py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center max-w-2xl mx-auto"
        >
          <span className="text-sm text-bp-primary uppercase tracking-[0.2em] font-semibold">Testimonios</span>
          <h2 className="font-heading text-3xl lg:text-5xl font-semibold tracking-tight mt-4">
            Miles de clientes felices en todo el mundo
          </h2>
          <div className="mt-5 flex items-center justify-center gap-2">
            <div className="flex">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="w-5 h-5 text-bp-primary fill-bp-primary" />
              ))}
            </div>
            <span className="text-sm text-[#A3A3A3]">4.9/5 · valoración promedio</span>
          </div>
        </motion.div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {TESTIMONIALS.map((t, i) => (
            <motion.div
              key={t.name}
              data-testid="testimonial-card"
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: (i % 3) * 0.08 }}
              className="relative rounded-2xl border border-bp-border bg-bp-surface p-7 transition-all duration-300 hover:-translate-y-1 hover:border-bp-primary/40 hover:shadow-[0_8px_30px_rgba(46,125,255,0.12)]"
            >
              <Quote className="absolute top-6 right-6 w-8 h-8 text-bp-primary/20" />
              <div className="flex mb-4">
                {[...Array(t.rating)].map((_, s) => (
                  <Star key={s} className="w-4 h-4 text-bp-primary fill-bp-primary" />
                ))}
              </div>
              <p className="text-[#D4D4D4] text-sm leading-relaxed">"{t.text}"</p>
              <div className="mt-6 flex items-center gap-3">
                <span className="grid place-items-center w-11 h-11 rounded-full bg-bp-primary/15 text-bp-primary font-heading font-semibold text-sm">
                  {initials(t.name)}
                </span>
                <div>
                  <div className="text-white font-medium text-sm">{t.name}</div>
                  <div className="text-xs text-[#737373]">{t.location}</div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
